import React, { useState } from 'react';
import { func, shape, string } from 'prop-types';
import { useStore } from 'Store';

import VerifyCode from './VerifyCode';

/**
 * @typedef {{ type: string, code: string }} CodeParams
 * @typedef {{ onSubmitted(params: CodeParams): void, onGetHelp(): void, data: Object }} Props
 * @typedef {{ username: string, errorMessage: string | null }} State
 */

/**
 * @param {Props} props
 */
const VerifyCodePassword = ({ onSubmitted, onGetHelp, data, navigation }) => {
    const { appManager } = useStore();
    const [errorMessage, setErrorMessage] = useState(null);

    const checkCode = async (code) => {
        const { type } = data;
        try {
            await appManager.api.checkPinResetCode({ type, code });
            onSubmitted({ type, code });
        } catch (error) {
            setErrorMessage(error.localizedMessage);
        }
    };

    return (
        <VerifyCode
            onSubmitted={checkCode}
            errorMessage={errorMessage}
            onGetHelp={onGetHelp}
            navigation={navigation}
        />
    );
};

VerifyCodePassword.propTypes = {
    data: shape({ type: string }).isRequired,
    onSubmitted: func.isRequired,
    onGetHelp: func.isRequired
};

export default VerifyCodePassword;
